module.exports = __webpack_public_path__ + "img/Ceph.61781d2.svg";